module.exports = __webpack_public_path__ + "img/team.a592d0c8.png";